(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/utils/helpers.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/utils/helpers.js');
"use strict";

const _React = React,
  useCallback = _React.useCallback;
const _svs$components$tipse = svs.components.tipsen.engine.actions,
  generateSportPixCoupon = _svs$components$tipse.generateSportPixCoupon,
  generateSportPixCouponBoard = _svs$components$tipse.generateSportPixCouponBoard;
const useGenerateSportPixCouponAction = () => useCallback(generateSportPixCoupon, []);
const useGenerateSportPixCouponBoardAction = () => useCallback(generateSportPixCouponBoard, []);
setGlobal('svs.components.tipsen.engine.utils.helpers', {
  useGenerateSportPixCouponAction,
  useGenerateSportPixCouponBoardAction
});

 })(window);